import { render, staticRenderFns } from "./SettingLeftSection.vue?vue&type=template&id=9f55ad2e&scoped=true"
import script from "./SettingLeftSection.vue?vue&type=script&lang=js"
export * from "./SettingLeftSection.vue?vue&type=script&lang=js"
import style0 from "./SettingLeftSection.vue?vue&type=style&index=0&id=9f55ad2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f55ad2e",
  null
  
)

export default component.exports